interface BusinessData {
  company_name: string;
  address?: string;
  city?: string;
  postal_code?: string;
  country?: string;
}

interface EmailFooterOptions {
  businessData: BusinessData;
  unsubscribeUrl: string;
  recipientEmail: string;
}

export function generateEmailFooter({ businessData, unsubscribeUrl, recipientEmail }: EmailFooterOptions): string {
  const { company_name, address, city, postal_code, country } = businessData;

  const hasAddress = address && city && postal_code;

  const addressLine = hasAddress
    ? `${company_name}, ${address}, ${postal_code} ${city}${country && country !== 'Nederland' ? ', ' + country : ''}`
    : company_name;

  return `
    <div style="margin-top: 40px !important; padding-top: 15px !important; border-top: 1px solid #e5e7eb !important; font-family: Arial, Helvetica, sans-serif !important;">
      <table cellpadding="0" cellspacing="0" border="0" width="100%" style="margin: 0 auto !important; text-align: center !important;">
        <tr>
          <td style="padding: 0 !important;">
            <p class="footer-text" style="margin: 0 0 8px 0 !important; font-size: 12px !important; color: #6b7280 !important; line-height: 1.5 !important; font-family: Arial, Helvetica, sans-serif !important;">
              Verstuurd naar: <a href="mailto:${recipientEmail}" style="color: #3b82f6 !important; text-decoration: underline !important;">${recipientEmail}</a>
            </p>
            <p class="footer-text" style="margin: 0 0 8px 0 !important; font-size: 12px !important; color: #6b7280 !important; line-height: 1.5 !important; font-family: Arial, Helvetica, sans-serif !important;">
              <a href="${unsubscribeUrl}" class="footer-link" style="color: #3b82f6 !important; text-decoration: underline !important;">Uitschrijven</a>
            </p>
            <p class="footer-text" style="margin: 0 !important; font-size: 11px !important; color: #9ca3af !important; line-height: 1.5 !important; font-family: Arial, Helvetica, sans-serif !important;">
              ${addressLine}
            </p>
          </td>
        </tr>
      </table>
    </div>
  `;
}

export function parseFirstNamePlaceholder(text: string, firstName: string | null): string {
  return text.replace(/\{\{first_name(\|([^}]+))?\}\}/g, (match, pipe, fallback) => {
    if (firstName) {
      return firstName;
    }
    return fallback || 'lezer';
  });
}
